import React, { useState } from "react";
import { useTab } from "../../../contexts/tab";
import classNames from "classnames";
import { deleteIcon, editIcon } from "../../icon";
import UpForm from "../forms/UpForm";
import DeleteUpModal from "../forms/DeleteUpModal";
import ShimmerTable from "../../shimmer/ShimmerTable";
import { useAuth } from "../../../contexts/auth";
import { useFormik } from "formik";
import { basePath } from "../../config";
import { toast } from "react-toastify";

export default function TabBodyUps() {
  const [{ tabData }, { setTabData }] = useTab();
  const [isOpen, setIsOpen] = useState(false);
  const [upToEdit, setUpToEdit] = useState(null);
  const [upToDelete, setUpToDelete] = useState(null);
  const [{ activeUser }] = useAuth();

  function handaleEdit(label) {
    const [width, height] = label?.size?.split("X") || [];
    setUpToEdit({ ...label, width, height });
    setIsOpen(true);
  }

  async function submitFormData(values) {
    try {
      const res = await fetch(basePath + "getFilteredUps", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${activeUser?.remember_token}`,
        },
        body: JSON.stringify(values),
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData({ data: JSON.parse(data.data), links: [] });
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      ups: "",
    },
    onSubmit: (values, actions) => {
      submitFormData(values, actions, activeUser);
    },
  });

  async function handleReset() {
    formik.resetForm({
      ups: "",
    });

    setTabData(null);
    const restApi = "getUps";

    try {
      const res = await fetch(basePath + restApi, {
        method: "post",
        headers: {
          Authorization: `Bearer ${activeUser?.remember_token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      if (res.status === 401) {
        toast.error(data.message);
        document.cookie =
          "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      }

      if (data.status) {
        setTabData(JSON.parse(data.data));
      } else {
        setTabData(null);
      }
    } catch (error) {
      setTabData(null);
      console.error("TabProvider:: api calling fail =>", error);
    }
  }

  return (
    <div>
      <div className="flex justify-between bg-slate-200 mb-4 items-center p-2 rounded-md">
        <form
          className="flex gap-3 items-center"
          onSubmit={formik.handleSubmit}
        >
          <label>
            <span className="mr-3">Search:</span>
            <input
              className="rounded-sm py-1 px-2"
              value={formik.values.ups}
              onChange={formik.handleChange}
              type="text"
              name="ups"
              placeholder="Search Ups"
            />
          </label>

          <button className="bg-white rounded-sm px-2 py-1" type="submit">
            Submit
          </button>
          <button
            onClick={handleReset}
            className="bg-white rounded-sm px-2 py-1"
            type="button"
          >
            Reset
          </button>
        </form>

        {activeUser?.user_permission <= 2 && (
          <button
            onClick={() => setIsOpen(true)}
            className="bg-orange text-white p-2 rounded-md mb-4"
          >
            Add Ups
          </button>
        )}
      </div>

      <UpForm
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        upToEdit={upToEdit}
        setUpToEdit={setUpToEdit}
      />
      <DeleteUpModal setUpToDelete={setUpToDelete} upToDelete={upToDelete} />

      {!tabData && <ShimmerTable />}
      {tabData && (
        <table className="dataTable">
          <thead>
            <tr>
              <th scope="col">No</th>
              <th scope="col">Ups</th>
              <th scope="col">Note</th>
              {activeUser?.user_permission <= 2 && <th scope="col">Action</th>}
            </tr>
          </thead>
          <tbody>
            {tabData.data.map(({ id, ups, note }, i) => {
              return (
                <tr key={id}>
                  <td scope="col">{i + (tabData.from || 1)}</td>
                  <td scope="col">{ups}</td>
                  <td scope="col">{note}</td>
                  {activeUser?.user_permission <= 2 && (
                    <td scope="col">
                      <button
                        className="bg-green-600 p-2 rounded-md my-1"
                        onClick={() => handaleEdit({ id, ups, note })}
                      >
                        {editIcon}
                      </button>
                      <button
                        className={classNames("p-2 rounded-md ml-2 bg-orange")}
                        onClick={() => setUpToDelete({ id, ups })}
                      >
                        {deleteIcon}
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
